export function getAvailableVariants(product) {
  const variants = product?.variants || [];

  return variants.filter((variant) => variant.isInStock !== false);
}

export function getProductStock(product) {
  const variants = product?.variants || [];
  const availableVariants = getAvailableVariants(product);

  const explicitAvailability =
    product?.isInStock !== undefined ? Boolean(product.isInStock) : null;

  const isInStock =
    explicitAvailability !== null
      ? explicitAvailability
      : variants.length === 0
        ? true
        : availableVariants.length > 0;

  const availableQuantity =
    product?.availableQuantity !== undefined &&
    product?.availableQuantity !== null
      ? Number(product.availableQuantity)
      : availableVariants.reduce(
          (total, variant) => total + Number(variant.availableQuantity || 0),
          0,
        );

  return {
    isInStock,
    availableQuantity,
    availableVariants,
  };
}